import { VStack } from '@talos/kyoko';
import { defaultUnsettledTransactionsColumns, UNSETTLED_TRANSACTIONS_BLOTTER_ID } from '../tokens';
import { UnsettledTransactionsBlotter } from './UnsettledTransactionsBlotter';
import { LP_SETTLEMENT_BLOTTER_PORTAL_ID } from './tokens';

interface UnsettledTransactionsProps {
  batchID?: string;
}

export function UnsettledTransactions({ batchID }: UnsettledTransactionsProps) {
  return (
    <VStack w="100%" h="100%" data-testid="unsettled-transactions-blotter" alignItems="flex-start">
      <UnsettledTransactionsBlotter
        blotterID={UNSETTLED_TRANSACTIONS_BLOTTER_ID}
        portalID={LP_SETTLEMENT_BLOTTER_PORTAL_ID}
        defaultColumns={defaultUnsettledTransactionsColumns}
        batchID={batchID}
      />
    </VStack>
  );
}
